import { createAction } from 'typesafe-actions';
import { createRoutine } from '../common/utils/new-routines';

export type ExportActionPayload = {
  exportId: string;
  userId?: string;
};

export const projectExportRoutine = createRoutine('project/PROJECT_EXPORT')<
  undefined,
  undefined,
  undefined,
  ExportActionPayload,
  string,
  undefined
>();
export type ProjectExportRoutine = typeof projectExportRoutine;

export const projectExportCompleted = createAction('project/PROJECT_EXPORT_COMPLETED')<ExportActionPayload>();
export type ProjectExportCompleted = typeof projectExportCompleted;

export const resetProjectExport = createAction('project/PROJECT_EXPORT_RESET')();
export type ResetProjectExport = typeof resetProjectExport;
